<header class="page-header">
    <div>
        <a href="../index.html" class="logo-container">
            <img src="assets/images/gorilla-s10-autoriaszto.svg" alt="Gorilla Logo">
            <span class="Navigation--currentPageName">
                A <span class="general-font">General Track</span> csoport tagja
            </span>
        </a>
        <a href="#bundles-section" id="Mobil-kiemelt-menu" style="
    background: green;
    border-radius: 5px;
    padding: 5px;
    color: white;
    font-weight: 500;
">Rendelések,árak</a>
        <div class="navigation" style="margin: 5px 0;">
            <svg class="hamburger-button" [ngClass]="menuOpened ? 'cross' : ''" (click)="openMenu()" viewBox="0 0 800 600">
                <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top"></path>
                <path d="M300,320 L540,320" id="middle"></path>
                <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
            </svg>
        </div>
    </div>
</header>
<nav id="top-menu" role="navigation" [ngClass]="menuOpened ? 'active' : ''">
    <header id="mobile-menu-header" style="display: flex; justify-content: center; align-items: center; background: #1778bb;">
        <h1 style="color: white; font-size: 22px; padding: 20px 0; margin: 0; backdrop-filter: brightness(70%); width: 100%; height: 100%; text-align: center;">Menü</h1>
    </header>
    <ul>
        <li>
            <a href="../index.html#device">Tulajdonságok</a>
        </li>
        <li>
            <a  id="kiemelt-menu" href="../index.html#bundles-section" style="font-weight:bold;">Rendelés, árak</a>
        </li>
        <li>
            <a href="../index.html#installers_anchor">Beszerelőink</a>
        </li>
        <li>
            <a href="#">Sajtómegjelenések</a>
        </li>
        <li>
            <a href="../tudastar.html">Tudásbázis</a>
        </li>
        <li>
            <a href="../about-us.html">Rólunk</a>
        </li>
        <li>
            <a href="../index.html#ajanlat-keres">Kapcsolat</a>
        </li>
        <li class="right">
            <a id="loginOnFleetAnchor" href="https://www.general-track.com/fleet/" target="_blank"><span style="padding-right: 6px;"  data-translate-text>Belépés</span> <fa-icon [icon]="icons.externalLink"></fa-icon></a>
        </li>
    </ul>
</nav>
